<!--
 * @Author: chenguanghua
 * @Date: 2022-07-26
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 16:48:04
 * @Description: 代办报告项目
-->
<template>
  <div
    v-loading="loading"
    class="l-page l-page--search"
  >
    <!-- 页面头部 Start -->
    <div
      class="l-page__header c-page__header"
    >
      <!-- 页面标题 -->
      <h2
        v-menu-title
        class="c-page__header-title"
      >
        代办报告项目
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div
        class="c-page__header-btns"
      >
        <k-button
          btn-text="查询"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-search"
          @click="refreshSearch()"
        />
        <k-button
          btn-text="重置"
          :auth-type="false"
          icon="kestrel-icon ki-repeat"
          @click="resetForm()"
        />
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 查询条件 Start -->
    <div
      class="l-page__item l-page--search__item"
    >
      <hm-page-card
        title="查询条件"
        class="c-card--condition"
      >
        <!-- 查询条件表单 Start -->
        <!-- tips：c-condition__form类用于查询类布局的查询条件模块使用 -->
        <el-form
          ref="filterParams"
          class="c-form c-condition__form"
          :model="filterParams"
          :inline="true"
          :rules="filterParamsRules"
          label-position="right"
          label-width="80px"
          label-suffix="："
        >
          <el-row
            class="c-form__row"
          >
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="客户名称"
                prop="khmc"
              >
                <el-input
                  v-model.trim="filterParams.khmc"
                  class="c-form__input"
                  placeholder="客户名称"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="项目名称"
                prop="xmmc"
              >
                <el-input
                  v-model.trim="filterParams.xmmc"
                  class="c-form__input"
                  placeholder="项目名称"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="计划开始时间"
                label-width="120px"
                prop="jhkssj"
              >
                <hm-date-range
                  v-model="filterParams.jhkssj"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  :clearable="true"
                />
              </el-form-item>
            </el-col>
            <!-- <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="录入单位"
                prop="lrdw"
              >
                <el-select
                  v-model="filterParams.lrdw"
                  class="c-form__select"
                  style="width: 100%;"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in lxList"
                    :key="item.key"
                    :value="item.value"
                    :label="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col
              class="c-form__col"
              :span="12"
            >
              <template>
                <el-form-item
                  class="c-form__item"
                  label="所属区域"
                  prop="ssqy"
                >
                  <select-address
                    :address.sync="filterParams.address"
                  />
                </el-form-item>
              </template>
            </el-col>
          </el-row>
        </el-form>
        <!-- 查询条件表单 End -->
      </hm-page-card>
    </div>
    <!-- 查询条件 End -->

    <!-- 页面主内容：查询列表 Start -->
    <div
      class="l-page__body l-page--search__body"
    >
      <!-- tips：l-page__tabs--single类用于只有一个tab时修饰页面使用 -->
      <el-tabs
        type="border-card"
        class="l-page__tabs l-page__tabs--single"
      >
        <el-tab-pane
          label="查询结果"
        >
          <!-- table的ref的命名根据业务名称修改 -->
          <k-table
            ref="dbbgTable"
            height="100%"
            :table-column="tableColumn"
            :data="page.rows"
            :pagination="page"
            @current-change="search"
            @size-change="handleSizeChange"
          >
            <template
              #xmmc="scope"
            >
              <el-link
                type="primary"
                @click="openNavTab({ name: 'viewWbjh', params: { id: scope.row.id } })"
              >
                {{ scope.row.xmmc }}
              </el-link>
            </template>
            <template
              #qzsj="scope"
            >
              {{ scope.row.sjq | date("yyyy-MM-dd ") }}  至 {{ scope.row.sjz | date("yyyy-MM-dd ") }}
            </template>
          </k-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 页面主内容：查询列表 End -->
  </div>
</template>

<script>
import { dbbgManageService } from './dbbg.service.js';
export default {
  name: 'Dbbg',
  data () {
    return {
      loading: false, // 页面是否loading状态
      lxList: [{
        key: '1',
        value: '类型1'
      }, {
        key: '2',
        value: '类型1'
      }],
      djrq: [], // 登记类型
      /* 查询条件（页面绑定的查询条件） start */
      filterParams: {
        khmc: null, // 客户名称
        xmmc: null, // 项目名称
        lrdw: null,
        jhkssj: [null, null], // 计划开始时间
        jhkssjq: null, // 计划开始时间起
        jhkssjz: null, // 计划开始时间止
        city: null, // 省
        district: null, // 市
        province: null, // 区
        address: null
      },
      /* 查询条件 end */

      /* 表单校验规则 Start */
      filterParamsRules: {
        jhkssj: [this.$HMValidator.dateRange('计划开始时间')
        ]
      },
      /* 表单校验规则 End */

      /* 弹窗 start */
      showDialogName: '',
      dialogParams: {},
      /* 弹窗 end */

      /* 分页实际查询条件（避免查询条件的双向绑定导致点击分页按钮，获取到的数据不符合真实过滤条件） Start */
      trueFilterParams: {},
      /* 分页实际查询条件 End */

      /* 导出实际查询条件（避免查询条件的双向绑定导致点击导出按钮，获取到的数据与查询结果不一致） Start */
      exportFilterParams: {},
      /* 导出实际查询条件 End */

      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      /* 查询结果 End */

      /* 表格列配置Start */
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'xmmc', slotName: 'xmmc', label: '项目名称', align: 'left', minWidth: '120', type: 'text' },
        { key: 'khmc', label: '客户名称', align: '', minWidth: '180', type: 'text' },
        { key: 'qzsj', slotName: 'qzsj', label: '起止时间', align: 'center', minWidth: '220', type: 'text' },
        { key: 'jhzt', label: '计划状态', align: 'left', width: '130', type: 'text' },
        // { key: 'lrdw', label: '录入单位', align: 'left', width: '130', type: 'text' },
        { key: 'createTime', label: '创建时间', align: 'center', minWidth: '220', type: 'dateTime' }
      ]
      /* 表格列配置End */

    };
  },
  methods: {
    /**
     * @description: 记录分页查询条件，调用查询方法
     * @return {*}
     */
    refreshSearch () {
      if (this.$refs.filterParams) {
        this.$refs.filterParams.validate(valid => {
          if (valid) {
            this.initFilterParams();
          }
        });
      } else {
        this.initFilterParams();
      }
    },
    /**
     * 初始化查询条件
     */
    initFilterParams () {
      if (this.filterParams.address) {
        const address = JSON.parse(this.filterParams.address);
        this.filterParams.province = address[0] ? address[0].name : null;
        this.filterParams.district = address[1] ? address[1].name : null;
        this.filterParams.city = address[2] ? address[2].name : null;
      }
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      [this.trueFilterParams.jhkssjq, this.trueFilterParams.jhkssjz] = this.trueFilterParams.jhkssj;
      this.search();
    },
    /**
     * @description: 查询列表方法
     * @param {number} _pageNo
     * @return {*}
     */
    search (_pageNo = 1) {
      /* 处理分页参数 Start */
      this.trueFilterParams.pageSize = this.page.pageSize;
      this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 End */

      this.loading = true;
      dbbgManageService.query(this.trueFilterParams)
        .then(rsp => {
          this.page = Object.assign({}, this.page, rsp.data);
          console.log(this.page);
          // this.list = this.page.rows;
          // 导出条件更新为查询使用的条件
          this.exportFilterParams = JSON.parse(JSON.stringify(this.trueFilterParams));
        })
        .catch(err => {
          console.error('查询错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.search();
    },
    /**
     * @description: 重置页面为初始状态
     * @param：
     * @return {*}
     */
    resetForm () {
      this.$refs.filterParams.resetFields();
    },
    /**
       * @description: 跳转到查看
       * @author: cgh
       */
    handleDialog (_name, _params) {
      this.showDialogName = _name;
      this.dialogParams = _params;
    },
    /**
     * @description: 删除
     * @return {*}
     */
    handleDel (_row) {
      const _this = this;
      _this.$confirm('是否确认删除此巡查测试登记任务？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        dbbgManageService.delete(_row.id)
          .then(rsp => {
            _this.$alert('删除成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            _this.search();
          })
          .catch(err => {
            console.error('删除失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    },
    /**
     * @description: 导出业务流程
     * @param {*}
     * @return {*}
     */
    handleExport () {
      this.loading = true;
      dbbgManageService.export(this.exportFilterParams)
        .then(rsp => {
          const fileStream = rsp.data;
          const fileName = decodeURIComponent(escape(rsp.headers['content-disposition'].split('=')[1]));
          this.$HMUtil.downloadStreamFile(fileStream, fileName);
        })
        .catch(err => {
          console.error('导出错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created () {
    this.refreshSearch();
  },
  activated () {
    if (this.$route.params.isRefresh) {
      this.refreshSearch();
    }
  }
};
</script>
